import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthLoginComponent } from './auth-login/auth-login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { MultifactorAuthenticationComponent } from './multifactor-authentication/multifactor-authentication.component';
import { AuthSignupComponent } from './auth-signup/auth-signup.component';
import { AssignAdministratorComponent } from './assign-administrator/assign-administrator.component';
import { HelpCenterComponent } from './help-center/help-center.component';


@NgModule({
  declarations: [
    AuthLoginComponent,
    ResetPasswordComponent,
    MultifactorAuthenticationComponent,
    AuthSignupComponent,
    AssignAdministratorComponent,
    HelpCenterComponent
  ],
  imports: [
    CommonModule
  ]
})
export class AuthModule { }
